import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Address } from 'src/app/shared/models/address';
import { ServiceCenter } from 'src/app/shared/models/service-center';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Beneficiaire } from 'src/app/shared/models/beneficiaire';
import { PARAM_LABEL_BENEFICIAIRE } from 'src/app/core/services/constant/constants.service';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { CareSkill } from 'src/app/shared/models/employee/care-skill';

@Component({
	selector: 'app-beneficiaire-modal-ajout-form',
	templateUrl: './beneficiaire-modal-ajout-form.component.html',
	styleUrls: ['./beneficiaire-modal-ajout-form.component.scss']
})
export class BeneficiaireModalAjoutFormComponent implements OnInit {
	LABEL_BENEFICIAIRE: string;
	serviceCenter: ServiceCenter;

	isAddressSelected: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: true };

	isPreferencesActive = false;

	beneficiaire = new Beneficiaire();

	MAX_NAME_CHAR = 25;
	NAME_PATTERN =
		"^[0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+( [0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+)*$";
	form = new FormGroup({
		firstName: new FormControl('', [
			Validators.required,
			Validators.minLength(1),
			Validators.maxLength(this.MAX_NAME_CHAR),
			Validators.pattern(this.NAME_PATTERN)
		]),
		lastName: new FormControl('', [
			Validators.required,
			Validators.minLength(1),
			Validators.maxLength(this.MAX_NAME_CHAR),
			Validators.pattern(this.NAME_PATTERN)
		]),
		address: new FormControl(new Address().label, [Validators.maxLength(60)]),
		preferredEmployee1: new FormControl(''),
		preferredEmployee2: new FormControl(''),
		preferredEmployee3: new FormControl(''),
		incompatibleEmployee1: new FormControl(''),
		incompatibleEmployee2: new FormControl(''),
		incompatibleEmployee3: new FormControl(''),
		area: new FormControl('Non spécifié'),
		tel: new FormControl(''),
		email: new FormControl('')
	});

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;
	isSAE = false;

	@Output() updateListing = new EventEmitter();

	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private toastService: ToastService
	) {}

	ngOnInit(): void {
		this.LABEL_BENEFICIAIRE =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_BENEFICIAIRE
			);
		this.isPreferencesActive =
			this.facade.dataStorageService.isPreferencesBeneficiaireActive();
		this.isSESSAD = this.facade.dataStorageService.isSESSAD();
		this.isSAAD = this.facade.dataStorageService.isSAAD();
		this.isSSIAD = this.facade.dataStorageService.isSSIAD();
		this.isSAE = this.facade.dataStorageService.isSAE();
	}

	onSubmit() {
		this.isValidateButtonClicked.value = true;
		this.facade.beneficiaireService
			.addBeneficiaire(this.beneficiaire)
			.subscribe({
				next: (addedBeneficiaireId: number) => {
					this.beneficiaire.id = addedBeneficiaireId;
					this.isValidateButtonClicked.value = false;
					this.bsModalRef.hide();
					this.updateListing.emit(this.beneficiaire);
				},
				error: (err: ErrorResponse) => {
					this.isValidateButtonClicked.value = false;
					this.toastService.createHttpErrorToast(
						err.error.response,
						err.status
					);
				}
			});
	}
}
